// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3gBo0","title":"AfterBackImages_title__1QuH8","images":"AfterBackImages_images__2K61_"};